<template>
  <div class="box" style="display: flex;justify-content: center;">
    <!-- 通栏底部 -->
    <div class="common-bottom">
      <div class="box">
        <div class="line"></div>
        <div class="title">
          <!-- 傲天游戏，快乐生活！ -->
        </div>
        <div class="textOne">杭州傲天科技有限公司  © 2006-2024 ao-t.com, All Rights Reserved</div>
        <div class="textTwo">增值电信业务许可证：浙B2-20190442 网络文化经营许可证：浙网文〔2016〕0293-163号</div>
        <div class="textTwo" style="cursor: pointer;" @click="pcOutLink1"> ICP备案号:浙B2-20130216-1</div>
        <div class="textTwo"  style="cursor: pointer;"  @click="pcOutLink2">
          <img style="width: 15px;height: 15px;" src="../assets/newImg/zjga.png" alt="">
          浙公网安备 :33010802003154号
        </div>
        <div class="imgBox" style="margin-top: 10px;">
          <img style="margin-right: 10px;" src="../assets/newImg/link_1.jpg" alt="">
          <img src="../assets/newImg/link_2.jpg" alt="">
        </div>
      </div>
      <!-- 移动端 -->
      <div class="mobile-box">
        <div class="line"></div>
        <div class="title">
          <!-- 傲天游戏，快乐生活！ -->
        </div>
        <div class="textOne">杭州掌动科技股份有限公司</div>
        <div class="textOne">© 2006-2024 ao-t.com, All Rights Reserved</div>
        <!-- ©2013-2020 zdjoys.com，All Rights Reserve -->
        <div class="textTwo">增值电信业务许可证：</div>
        <div class="textTwo">浙B2-20190442 网络文化经营许可证：浙网文〔2016〕0293-163号</div>
        <div class="textTwo" @click="pcOutLink1">ICP备案号:浙B2-20130216-1</div>
        <div class="textTwo" @click="pcOutLink2">
          <img style="width: 15px;height: 15px;" src="../assets/newImg/zjga.png" alt="">
          浙公网安备 :33010802003154号
        </div>
        <div class="imgBox" style="margin-top: 10px;">
          <img style="margin-right: 10px;width:80px;height: 35px;" src="../assets/newImg/link_1.jpg" alt="">
          <img style="width:80px;height: 35px;" src="../assets/newImg/link_2.jpg" alt="">
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    pcOutLink1 () {
      window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank')
    },
    pcOutLink2 () {
      window.open('https://www.beian.gov.cn/portal/recordQuery?token=33010802003143', '_blank')
    }
  }
} 
</script>

<style lang="scss" scoped>
@media (min-width: 992px) {
  // 通栏底部

  .common-bottom {
    width: 1400px;
    height: 300px;
    // background-color: #01bdb0;
    background-image: linear-gradient(to bottom, #0d496c, #047895, #01bdb0);

    .mobile-box {
      display: none;
    }

    .box {
      text-align: center;
      padding-top: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 0 !important;
      .line {
        // width: 1920px;
        width: 100%;
        height: 1px;
        background: linear-gradient(225deg, rgba(255, 255, 255, 0) 0%, #ffffff 51%, rgba(255, 255, 255, 0) 100%);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
      }

      .title {
        color: #ffebd8;
        font-size: 25px;
        margin: 20px 0;
      }

      .textOne {
        color: #ffebd8;
        font-size: 14px;
        // margin-bottom: 15px;
      }

      .textTwo {
        color: #ffebd8;
        font-size: 14px;
        margin: 5px 0;
      }
    }
  }
}
@media (max-width: 750px) {
  .common-bottom {
    width: 100%;
    margin-top: 10px;
    height: 200px;
    background-image: linear-gradient(to bottom, #0d496c, #047895, #01bdb0);

    .box {
      display: none;
    
    }

    .mobile-box {
      padding: 24px 0 0 0;
      text-align: center;

      .line {
        // width: 1920px;
        width: 100%;
        height: 1px;
        background: linear-gradient(225deg, rgba(255, 255, 255, 0) 0%, #ffffff 51%, rgba(255, 255, 255, 0) 100%);
        // border-radius: 0px 0px 0px 0px;
        opacity: 1;
      }

      .title {
        color: #ffebd8;
        font-size: 16px;
        margin: 5px 0;
      }

      .textOne {
        color: #ffebd8;
        font-size: 10px;
        transform: scale(0.83333);

        // margin-bottom: 15px;
      }

      .textTwo {
        color: #ffebd8;
        font-size: 10px;
        transform: scale(0.83333);
      }
    }
  }
}
</style>
